export * from './password.module';
export * from './password.component';
